import { Controller } from "stimulus";
import 'foundation-sites';
import $ from "jquery";

export default class extends Controller {
  static targets = ["menu", "options"];

  connect() {
    this.selectedItem = null;
    this.jobBox = document.querySelector(".dotted-box-location");
    this.jobTextComponent = document.querySelector(".job-text-selection-location");
    this.jobIcon = document.querySelector(".add-job-location");
    this.jobTextElement = document.getElementById("selected-location-types");
    this.applyButton = this.element.querySelector(".locations-apply-button");
    this.hintText = document.getElementById("hintText");
    this.searchImage = document.querySelector(".search-image");
    $(this.menuTarget).foundation();
    document.addEventListener('click', this.handleClickOutside.bind(this));
    this.extractAndApplySelection();
    this.hintText.classList.add("hidden")
    this.debounceTimeout = null;
    this.currentRequest = null; // Add this to track current request
    window.addEventListener('pageshow', this.handlePageShow.bind(this));

    // Add Escape key listener
    document.addEventListener('keydown', this.handleEscapePress.bind(this));

    // Define trackEvent if it doesn't exist
    if (typeof window.trackEvent !== 'function') {
      window.trackEvent = (eventName, eventData) => {
        console.log(`Analytics event: ${eventName}`, eventData);
        // In production, this would send data to your analytics service
      };
    }
  }

  disconnect() {
    window.removeEventListener('pageshow', this.handlePageShow.bind(this));
    document.removeEventListener('click', this.handleClickOutside.bind(this));
    document.removeEventListener('keydown', this.handleEscapePress.bind(this));
  
  }

  handlePageShow(event) {
    // PageShow fires when page is loaded from cache (back button)
    if (event.persisted) {
      this.syncFiltersWithURL();
    }
  }

  syncFiltersWithURL() {
    this.clearSelections(true);
    this.cancelOptions();
    this.extractAndApplySelection();
  }

  handleClickOutside(event) {
    const dropdown = this.menuTarget;
    const jobBox = document.querySelector(".recruiters-location-dropdown");

    if (!dropdown.contains(event.target) && !jobBox.contains(event.target)) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    this.hintText.classList.add("hidden");
    $(this.menuTarget).foundation('close');
    this.jobTextElement.classList.remove("opacity");
    this.jobIcon.classList.remove("opacity");
  }

  async searchLocations(event) {
    const query = event.target.value;

    if (query.trim().length > 0) {
      this.searchImage.classList.add("hidden");
    } else {
      this.searchImage.classList.remove("hidden");
    }

    // Cancel previous request
    if (this.currentRequest) {
      this.currentRequest.abort();
      this.currentRequest = null;
    }

    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(async () => {
      if (query.trim().length > 0) {
        this.hintText.classList.add("hidden");
        const suggestions = await this.fetchGoogleSuggestions(query.trim());
        this.updateOptions(suggestions);
      } else {
        this.optionsTarget.innerHTML = "";
        this.hintText.classList.remove("hidden");
      }

      this.toggleApplyButton(false);
    }, 300);
  }

  updateOptions(suggestions) {
    const optionsContainer = this.optionsTarget;
    optionsContainer.innerHTML = "";

    suggestions.forEach((suggestion) => {
      const optionElement = document.createElement("div");
      optionElement.classList.add("job-location-option");

      // Format display text based on location type
      const displayText = this.formatLocationDisplay(suggestion);
      optionElement.textContent = displayText;

      optionElement.setAttribute("data-action", "click->locations-marketplace#selectOption");

      // Store structured data
      optionElement.dataset.locationData = JSON.stringify(suggestion);

      optionsContainer.appendChild(optionElement);
    });
  }

  selectOption(event) {
    const displayText = event.currentTarget.textContent.trim();
    const locationData = JSON.parse(event.currentTarget.dataset.locationData);

    // Clear any previous selection
    const previousSelection = document.querySelector(`.job-location-option.selected`);
    if (previousSelection) {
      previousSelection.classList.remove('selected');
    }

    // Set new selection
    this.selectedItem = displayText;
    this.selectedLocationData = locationData;
    event.currentTarget.classList.add('selected');
    this.updateButtonText();
    this.toggleApplyButton(true);
  }

  async fetchGoogleSuggestions(query) {
    // Cancel previous request
    if (this.currentRequest) {
      this.currentRequest.abort();
    }

    // Create new AbortController for this request
    const controller = new AbortController();
    this.currentRequest = controller;

    try {
      const response = await fetch(
        `/google_places/marketplace_autocomplete?term=${encodeURIComponent(query)}`,
        { signal: controller.signal }
      );

      if (response.ok) {
        const data = await response.json();
        return data.places || [];
      } else {
        return [];
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        return []; // Request was cancelled
      }
      throw error;
    } finally {
      this.currentRequest = null;
    }
  }

  formatLocationDisplay(place) {
    switch (place.type) {
      case 'country':
        return place.country;
      case 'state':
        return `${place.state}, ${place.country}`;
      case 'city':
        return `${place.city}, ${place.state}, ${place.country}`;
      default:
        return 'Unknown location';
    }
  }

  openDropdown() {
    $(this.menuTarget).foundation('open');
    this.jobTextElement.classList.add("opacity");
    this.jobIcon.classList.add("opacity");

    // Initialize selectedJobs if needed
    this.selectedJobs = this.selectedJobs || [];

    if (document.getElementById("searchInput").value == "") {
      this.hintText.classList.remove("hidden");
    }
    this.menuTarget.focus();
    this.menuTarget.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'nearest',
      inline: 'nearest' 
    });
  }

  clearSelections(reset = true) {
    this.selectedItem = null;
    this.updateButtonText(true);
    this.jobBox.classList.remove("selected");
    if (reset === true) {
      this.hintText.classList.add("hidden");
    }
    else {
      this.hintText.classList.remove("hidden");
    }
  }

  clearOptions() {
    this.hintText.classList.add("hidden");
    this.clearSelections(true);
    $(this.menuTarget).foundation('close');
    this.toggleApplyButton(false);
    const currentUrl = new URL(window.location.href);

    // Remove all location-related parameters
    currentUrl.searchParams.delete("locations");
    currentUrl.searchParams.delete("locations[city]");
    currentUrl.searchParams.delete("locations[state]");
    currentUrl.searchParams.delete("locations[country]");
    currentUrl.searchParams.delete("locations[latitude]");
    currentUrl.searchParams.delete("locations[longitude]");

    window.location.href = currentUrl.toString();
  }

  cancelOptions() {
    document.getElementById("searchInput").value = "";
    const optionsContainer = this.optionsTarget;
    optionsContainer.innerHTML = "";
    this.selectedItems = [];
    this.toggleApplyButton(false);
    this.hintText.classList.add("hidden");
    this.searchImage.classList.remove("hidden");
    $(this.menuTarget).foundation('close');
    this.jobTextElement.classList.remove("opacity");
    this.jobIcon.classList.remove("opacity");
  }

  updateButtonText(isClear = false) {
    if (isClear || !this.selectedItem) {
      this.jobTextElement.innerHTML = "Any";
      this.jobTextComponent.style.marginLeft = "0.438rem";
      this.jobBox.style.justifyContent = "center";
      document.querySelector("button.dotted-box-location span img").style.display = "inline";
      this.toggleApplyButton(false);
      this.jobTextComponent.style.width = "auto";
    } else {
      this.jobTextElement.classList.remove("opacity");
      this.jobIcon.classList.remove("opacity");
      this.jobBox.style.justifyContent = "flex-start";
      this.jobBox.style.padding = "0.2rem 0.23rem";
      this.jobTextComponent.style.width = "100%";
      this.jobTextComponent.style.display = "flex";
      this.jobTextComponent.style.marginLeft = "0";
      this.jobTextComponent.style.gap = "0.2rem";
      document.querySelector("button.dotted-box-location span img").style.display = "none";
      this.jobTextElement.innerHTML = `<span class="selected-location">${this.selectedItem}</span>`;
    }
  }

  toggleApplyButton(enable) {
    if (enable) {
      this.applyButton.removeAttribute("disabled");
      this.applyButton.classList.remove("disabled");
    } else {
      this.applyButton.setAttribute("disabled", "disabled");
      this.applyButton.classList.add("disabled");
    }
  }

  applySelection(event) {
    // Stop event propagation to prevent triggering other controllers
    if (event) {
      event.stopPropagation();
    }

    window.trackEvent("Selected Location", {
      filters: this.selectedItem,
      userId: this.data.get("currentUser") || 'Visitors',
      source: 'Marketplace'
    });

    if (!this.selectedItem) {
      $(this.menuTarget).foundation('open');
    } else {
      this.jobTextElement.classList.remove("opacity");
      this.jobIcon.classList.remove("opacity");
      this.jobBox.classList.remove("selected");
      $(this.menuTarget).foundation('close');
    }

    this.locationsRedirection(event);
  }

  locationsRedirection(event) {
    if (this.selectedLocationData) {
      const currentUrl = new URL(window.location);
      const newParams = new URLSearchParams(currentUrl.search);

      // Clear page when location changes
      newParams.delete("page");

      // Clear all existing location parameters first
      newParams.delete("locations[city]");
      newParams.delete("locations[state]");
      newParams.delete("locations[country]");
      newParams.delete("locations[latitude]");
      newParams.delete("locations[longitude]");
      newParams.delete("locations"); // Legacy format

      // Add new structured location data
      if (this.selectedLocationData.type === 'country') {
        newParams.append("locations[country]", this.selectedLocationData.country);
      } else if (this.selectedLocationData.type === 'state') {
        newParams.append("locations[state]", this.selectedLocationData.state);
        newParams.append("locations[country]", this.selectedLocationData.country);
      } else if (this.selectedLocationData.type === 'city') {
        newParams.append("locations[city]", this.selectedLocationData.city);
        newParams.append("locations[state]", this.selectedLocationData.state);
        newParams.append("locations[country]", this.selectedLocationData.country);
      }

      // Add coordinates if available
      if (this.selectedLocationData.latitude && this.selectedLocationData.longitude) {
        newParams.append("locations[latitude]", this.selectedLocationData.latitude);
        newParams.append("locations[longitude]", this.selectedLocationData.longitude);
      }

      // Update the URL
      currentUrl.search = newParams.toString();
      window.location.href = currentUrl.toString();
    }
  }


   toggleDropdown(event) {
    event.preventDefault(); // stop <button> from submitting or following default toggle
    event.stopPropagation(); // stop Foundation's click handler from also running

    if (this.menuTarget.classList.contains('is-open')) {
      this.closeDropdown();
    } else {
      this.openDropdown();
      const simulatedEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
      this.menuTarget.dispatchEvent(simulatedEvent);
    }
  }
  
  extractAndApplySelection() {
    const urlParams = new URLSearchParams(window.location.search);

    // Check for structured location data
    const city = urlParams.get("locations[city]");
    const state = urlParams.get("locations[state]");
    const country = urlParams.get("locations[country]");

    if (city && state && country) {
      this.selectedLocationData = { type: 'city', city, state, country };
      this.selectedItem = `${city}, ${state}, ${country}`;
      this.updateButtonText();
    } else if (state && country) {
      this.selectedLocationData = { type: 'state', state, country };
      this.selectedItem = `${state}, ${country}`;
      this.updateButtonText();
    } else if (country) {
      this.selectedLocationData = { type: 'country', country };
      this.selectedItem = country;
      this.updateButtonText();
    } else {
      // Fallback to old format for backward compatibility
      const location = urlParams.get("locations");
      if (location) {
        this.selectedItem = decodeURIComponent(location.replace(/\+/g, " "));
        this.updateButtonText();
      }
    }
  }
  handleEscapePress(event) {
    if (event.key === "Escape") {
      this.closeDropdown();
    }
  }
}
